export const COUNTRIES_CODE = {
  BRA: 1,
  USA: 2,
  HAWAII: 38,
  NEW_YORK: 59
}

export const COUNTRIES_ISO_CODE = {
  BRA: 'BR',
  USA: 'US',
  AUT: 'AT',
  BGR: 'BG',
  GRC: 'GR',
  HUN: 'HU',
  ITA: 'IT',
  POL: 'PL',
  ROU: 'RO',
  CHE: 'CH',
  UKR: 'UA'
}

export const COUNTRIES_PHONE_CODE = {
  BRA: 55
}
